import type { Language } from "@/i18n/translations";

const estateValueLabels: Record<Language, Record<string, string>> = {
  cs: {},
  en: {
    Prodej: "Sale",
    Pronájem: "Rent",
    Byty: "Apartments",
    Domy: "Houses",
    Pozemky: "Land",
    Komerční: "Commercial",
    Ostatní: "Other",
    "6 a více": "6 and more",
    Atypický: "Atypical",
    Pokoj: "Room",
    Chata: "Cottage",
    "Památka/jiné": "Landmark/other",
    Rodinný: "Family house",
    Vila: "Villa",
    "Na klíč": "Turnkey",
    Chalupa: "Country cottage",
    "Zemědělská usedlost": "Farmstead",
    "Vícegenerační dům": "Multi-generation house",
    Bydlení: "Residential",
    Pole: "Fields",
    Lesy: "Forests",
    Louky: "Meadows",
    Zahrady: "Gardens",
    Rybníky: "Ponds",
    "Sady/vinice": "Orchards/vineyards",
    Kanceláře: "Offices",
    Sklady: "Warehouses",
    Výroba: "Production",
    "Obchodní prostory": "Retail premises",
    Ubytování: "Accommodation",
    Restaurace: "Restaurant",
    Zemědělský: "Agricultural",
    "Činžovní dům": "Apartment building",
    "Virtuální kancelář": "Virtual office",
    Ordinace: "Medical office",
    Apartmány: "Apartments",
    Garáž: "Garage",
    "Vinný sklep": "Wine cellar",
    "Půdní prostor": "Attic space",
    "Garážové stání": "Garage parking space",
    Mobilheim: "Mobile home",
    "Velmi dobrý": "Very good",
    Dobrý: "Good",
    Špatný: "Poor",
    "Ve výstavbě": "Under construction",
    Projekt: "Project",
    Novostavba: "New build",
    "K demolici": "For demolition",
    "Před rekonstrukcí": "Before reconstruction",
    "Po rekonstrukci": "After reconstruction",
    "V rekonstrukci": "Under reconstruction",
    Praha: "Prague",
  },
};

export function getEstateValueLabel(
  value: string | null | undefined,
  language: Language,
) {
  if (!value) {
    return value;
  }

  return estateValueLabels[language][value] ?? value;
}

export function getEstateValueListLabel(values: string[], language: Language) {
  return values.map((value) => getEstateValueLabel(value, language)).join(", ");
}
